import { Pipe, PipeTransform } from '@angular/core';
import { SignersService } from '@app/transaction-builder/services/signers.service';
import { ClientDocumentRelation } from 'ngx-mat-esign360';
import { ITxFormClientData } from '../model/transaction-form-data.model';

@Pipe({
  name: 'filterDocumentSigners',
})
export class FilterDocumentSignersPipe implements PipeTransform {
  constructor(private signersService: SignersService) {}

  transform(
    clients: ITxFormClientData[],
    docRelations: ClientDocumentRelation[]
  ): ITxFormClientData[] {
    return this.signersService.filterDocumentSigners(clients, docRelations);
  }
}
